import React from "react";
import { useParams } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { apiGetInvoicePublik } from "@/lib/publicApi";
import InvoiceA4 from "@/components/InvoiceA4";

// Addendum 5 (A5-C): the institution's invoice on its private nota link
// (/n/<token>/invoice); shows the last instalment printed by staff.
export default function InvoicePublik() {
  const { token } = useParams();
  const [d, setD] = React.useState(null);
  const [err, setErr] = React.useState(null);
  React.useEffect(() => { apiGetInvoicePublik(token).then(setD).catch(() => setErr(true)); }, [token]);
  if (err) return <div className="min-h-screen bg-white p-8 text-center text-slate-600">Invoice tidak ditemukan atau link sudah tidak berlaku.</div>;
  if (!d) return <div className="min-h-screen bg-white p-8 text-center text-slate-500"><Loader2 className="inline animate-spin" /> Memuat invoice…</div>;
  return (
    <div className="min-h-screen bg-slate-100 px-2 py-4 sm:px-4 sm:py-6 print:bg-white print:p-0">
      <div className="mx-auto mb-3 max-w-3xl px-4 text-right print:hidden">
        <button data-testid="invoice-publik-cetak" onClick={() => window.print()} className="inline-flex items-center gap-2 rounded bg-soq-biru px-4 py-2 text-sm text-white"><Printer size={14} /> Unduh PDF / Cetak</button>
      </div>
      <InvoiceA4 d={d} />
    </div>
  );
}
